export default __webpack_public_path__ + "static/media/INFOBEL.6c99874e.png";